import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';

export const { PersonalizationError } = errorFactory('PersonalizationError');

/** A generic error related to personalization. */
export type PersonalizationError = InstanceTypeOf<typeof PersonalizationError>;
